import { makeModuleStateSelector } from "@client/content/selectors";
import { getColorSelector, TargetSelector } from "@client/selectors";
import React from "react";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import { type MemberSurvey } from "./types";

export const localStateSelector = makeModuleStateSelector<MemberSurvey.AppState>(defaultState, previewState);

export const makeQuestionsSelector = () => createSelector([localStateSelector], (localState) => localState.questions);

export const makeAnswersSelector = () => createSelector([localStateSelector], (localState) => localState.answers);

export const makeSeparatorStyleSelector = () => {
  const separatorColorSelector = getColorSelector(TargetSelector.Entity, "separatorColor");

  return createSelector(
    [separatorColorSelector],
    (separatorColor): React.CSSProperties => ({
      backgroundColor: separatorColor,
      height: "1px"
    })
  );
};
